document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header-container');
  const burgerBtn = document.querySelector('.header-burger');
  const mobileMenu = document.querySelector('.header-mobile-menu');
  const closeBtn = document.querySelector('.header-mobile-close');
  const navLinks = document.querySelectorAll('.header-mobile-nav .header-nav-link');

  function checkScroll() {
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }

  window.addEventListener('scroll', checkScroll);
  checkScroll();

  function openMenu() {
    mobileMenu.classList.add('active');
    burgerBtn.classList.add('active');
    document.body.classList.add('noscroll');
    burgerBtn.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    mobileMenu.classList.remove('active');
    burgerBtn.classList.remove('active');
    document.body.classList.remove('noscroll');
    burgerBtn.setAttribute('aria-expanded', 'false');
  }

  burgerBtn.addEventListener('click', openMenu);
  closeBtn.addEventListener('click', closeMenu);

  navLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      closeMenu();

      const href = link.getAttribute('href');
      if (href && href.includes('#')) {
        const id = href.split('#')[1];
        const section = document.getElementById(id);
        if (section) {
          e.preventDefault();
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });
});